/* eslint no-use-before-define: 0 */
/**
 * Improve perceived performance by prefetching links on hover.
 */

// Watch for hover on all links and prefetch if hovered for 200ms

/**
 * @description Prefetches a URL
 * @param {event} e Hover event
 * @return {void}
 */
const prefetchAfterHover = (e) => {
  const link = e.target;
  const href = link.getAttribute('href');
  // Only prefetch if the link is to the same origin
  if (!href || !href.includes(window.location.origin)) {
    return;
  }
  requestIdleCallback(() => {
    // Handle prefetching then remove the event listeners.
    const prefetchLink = () => {
      const prefetch = document.createElement('link');
      prefetch.setAttribute('rel', 'prefetch');
      prefetch.setAttribute('href', href);
      document.head.appendChild(prefetch);
      // Remove the event listeners.
      link.removeEventListener('mouseover', prefetchAfterHover);
      link.removeEventListener('mouseout', cancelPrefetchOnMouseOut);

      // Remove the prefetch link element after 2s.
      setTimeout(() => {
        prefetch.remove();
      }, 2000);
    };

    // Prefetch after 50ms.
    const timeout = setTimeout(prefetchLink, 50);

    // Cancel the prefetch if the user moves the mouse away from the link.
    const cancelPrefetchOnMouseOut = () => {
      clearTimeout(timeout);
      link.removeEventListener('mouseout', cancelPrefetchOnMouseOut);
    };

    // Cancel the prefetch if the user moves their mouse off the link.
    link.addEventListener('mouseout', cancelPrefetchOnMouseOut);
  });
};

// Set up listener on all links in reuqestIdleCallback.
try {
  requestIdleCallback(() => {
    const allLinks = document.querySelectorAll('a');

    allLinks.forEach((link) => {
      link.addEventListener('mouseover', prefetchAfterHover);
    });
  });
} catch {
  // requestIdleCallback not supported.
  // Do nothing.
}
